





















































































import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import AppHeader from '@/components/AppHeader.vue';
import {
  HubButton,
  HubCard,
  HubColorPicker,
  HubHeading,
} from '@/components/HubComponents';
import BackgroundContainer from './BackgroundContainer.vue';
import ControlsContainer from './ControlsContainer.vue';
import WatermarkContainer from './WatermarkContainer.vue';

export default Vue.extend({
  name: 'ViewPlayer',

  components: {
    HubButton,
    HubCard,
    HubColorPicker,
    HubHeading,
    AppHeader,
    BackgroundContainer,
    ControlsContainer,
    WatermarkContainer,
  },

  props: {
    hash: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      menuButtons: [
        {
          icon: 'calendar-month-outline',
          label: this.$t('event'),
          href: `/event/${this.hash}`,
        },
        {
          icon: 'play',
          label: 'Player',
          href: `/player/${this.hash}`,
        },
        {
          icon: 'broadcast',
          label: 'Live Social',
          href: `/live-social/${this.hash}`,
        },
        {
          icon: 'chart-bar',
          label: this.$t('statistics'),
          href: `/statistics/${this.hash}`,
        },
      ],
      iframeKey: Date.now(),
      themeColor: '#ff0000',
      backgroundProps: {
        option: 'color',
        color: '#ffffff',
        imageSource: null,
        uploadingImageLoader: false,
      },
      controlProps: {
        like: 0,
        views: 0,
        autoplay: 0,
      },
      watermarkProps: {
        show: 0,
        positionSelected: '',
        opacity: 50,
        imageSource: null,
        uploadingImageLoader: false,
      },
    };
  },

  computed: {
    ...mapState(['user', 'events', 'player']),
    event(): Store.Events.Event {
      return this.events.event;
    },
    samplePlayerURL(): string {
      const { host } = window.location;
      const baseURL = /localhost/g.test(host)
        ? 'http://localhost:7025/evt' // local player
        : 'https://player.jmvstream.com/evt'; // prod player
      return `${baseURL}/${this.event.secret}/${this.event.event_hash}/sample.mp4`;
    },
    uploadingImageLoader(): boolean {
      return this.watermarkProps.uploadingImageLoader
        || this.backgroundProps.uploadingImageLoader;
    },
  },

  async mounted() {
    const eventLoaded = await this.loadEvent({
      planId: this.user.planId,
      hash: this.hash,
    });

    if (eventLoaded === 'error') {
      this.$router.push({
        name: 'Error',
        params: {
          error: '404',
          title: 'event_not_found',
          message: 'back_events_page',
        },
      });
    }

    const playerLoaded = await this.loadPlayerConfig({
      planId: this.user.planId,
      hash: this.hash,
    });

    if (playerLoaded === 'error') {
      this.$router.push({
        name: 'Error',
        params: {
          error: '404',
          title: 'Configurações do player não encontradas!',
          message: 'Volte para a página de eventos e tente novamente.',
        },
      });
    }

    // const defaultImageURL = '/uploads/2021-05-28/wbifeaBKJENRzeFnYQSoasoF.png';

    this.themeColor = this.player.config.theme_color || '#ff0000';
    this.backgroundProps.option = this.player.config.allow_background_image === 1 ? 'image' : 'color';
    this.backgroundProps.color = this.player.config.background_color || '#ffffff';
    this.backgroundProps.imageSource = this.player.config.background_image || null;
    this.controlProps.like = this.player.config.allow_like || 0;
    this.controlProps.views = this.player.config.show_statistics || 0;
    this.controlProps.autoplay = this.player.config.auto_play || 0;
    this.watermarkProps.show = this.player.config.show_watermark || 0;
    this.watermarkProps.positionSelected = this.player.config.watermark_position?.replace('-', '_')
      || 'bottom_right';
    this.watermarkProps.opacity = this.player.config.watermark_opacity;
    this.watermarkProps.imageSource = this.player.config.watermark
      ? this.player.config.watermark : null;
  },

  methods: {
    ...mapActions({
      loadEvent: 'events/loadEvent',
      loadPlayerConfig: 'player/loadPlayerConfig',
      updatePlayerConfig: 'player/updatePlayerConfig',
    }),
    async savePlayerConfig(): Promise<void> {
      const response = await this.updatePlayerConfig({
        planId: this.user.planId,
        hash: this.hash,
        fieldsToUpdate: {
          theme_color: this.themeColor,
          allow_background_color: this.backgroundProps.option === 'color' ? 1 : 0,
          background_color: this.backgroundProps.color,
          allow_background_image: this.backgroundProps.option === 'image' ? 1 : 0,
          background_image: this.backgroundProps.imageSource,
          allow_like: this.controlProps.like,
          show_statistics: this.controlProps.views,
          auto_play: this.controlProps.autoplay,
          show_watermark: this.watermarkProps.show,
          watermark_position: this.watermarkProps.positionSelected,
          watermark_opacity: this.watermarkProps.opacity,
          watermark: this.watermarkProps.imageSource,
        },
      });

      if (response === 'error') {
        this.$router.push({
          name: 'Error',
          params: {
            error: '400',
            title: 'Falha ao atualizar o player!',
            message: 'Volte para a página de customização e tente novamente.',
          },
        });
      }

      // refresh apenas no component de pré-visualização do player
      this.iframeKey = Date.now();
      // teste local
      // setTimeout(() => { this.iframeKey = Date.now(); }, 1000);
    },
    log(...args: string[]): void {
      console.log(args);
    },
  },
});
